import React, { memo } from 'react';

import { Box } from '@material-ui/core';

import BodyItem from './BodyItem';
import locales from '../../../../locales';
import { TNotification } from '../../../../types/INotificationsStore';
import { makeStyles } from "@material-ui/core/styles";

interface BodyVisitsProps {
  notification: TNotification;
}

const useStyles = makeStyles(() => ({
  firstBlock: {
    width: '20%',
  },
  otherBlock: {
    width: '40%',
  }
}));

function BodyVisits(props: BodyVisitsProps) {
  const { notification } = props;
  const classes = useStyles();

  const lastVisit = notification.getLastVisit();
  const totalVisits = notification.getTotalVisits();
  const averageReceiptAmount = notification.getAverageReceiptAmount();

  return (
    <Box display="flex" mb={2} mt={1}>
      <BodyItem
        className={classes.firstBlock}
        label={locales.t('notifications.properties.visits')}
        value={(totalVisits && totalVisits.toString()) || undefined}
      />

      <BodyItem
        className={classes.otherBlock}
        label={locales.t('notifications.properties.lastVisit')}
        value={(lastVisit && lastVisit.format('DD.MM.YY')) || undefined}
        rightIndent={0}
      />

      <BodyItem
        className={classes.otherBlock}
        label="Средний чек"
        value={averageReceiptAmount}
        rightIndent={0}
      />
    </Box>
  );
}

export default memo(BodyVisits);
